import { LocalStorageProvider } from '#Common/support'

const STORAGE_KEY = 'search-history'
const MAX_ITEMS = 10

/**
 * Client-side search query history (max 10).
 * Persist only on explicit submit (lupa / Enter) — callers invoke `add`.
 */
export function useSearchHistory() {
  const storage = new LocalStorageProvider()
  const items = ref<string[]>([])

  function load() {
    const raw = storage.get(STORAGE_KEY)
    if (!Array.isArray(raw)) {
      items.value = []
      return
    }
    items.value = raw
      .filter((entry): entry is string => typeof entry === 'string' && entry.trim().length > 0)
      .map(entry => entry.trim())
      .slice(0, MAX_ITEMS)
  }

  function persist() {
    storage.set(STORAGE_KEY, items.value)
  }

  function add(query: string) {
    const normalized = query.trim()
    if (!normalized) return

    items.value = [
      normalized,
      ...items.value.filter(
        entry => entry.toLowerCase() !== normalized.toLowerCase(),
      ),
    ].slice(0, MAX_ITEMS)
    persist()
  }

  function clear() {
    items.value = []
    persist()
  }

  if (import.meta.client) {
    load()
  }

  return {
    items: readonly(items),
    add,
    clear,
    load,
    maxItems: MAX_ITEMS,
  }
}
